module.exports = __webpack_public_path__ + "static/team-home-7ba1b977d4529d927abca96042dfe21b.svg";